import styled, { css } from 'styled-components'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { Noto_body3_r12 } from 'src/styles/fonts/NotoSansKrFonts'
import { MainPageProps } from 'src/pages/MainPage'
import { ellip, mediaMaxWidth } from 'src/styles/mixin'
import RenderIf from 'src/components/common/RenderIf'
import main_category_shortcut_all_icon from 'src/assets/images/main/main_category_shortcut_all.png'
import usePageNav from 'src/hooks/usePageNav.hook'
import LazyImage from 'src/components/common/LazyImage'
const MainCategoryShortcut = ({ categoryList }: MainPageProps) => {
  const { alwaysPageNav } = usePageNav()

  return (
    <S.MainCategoryShortcutContainer>
      <S.MainCategoryItemsContainer>
        {categoryList?.map(({ CategoryImage, CategoryName, CategoryNumber }, i) => (
          <RenderIf when={i < 8 && !!CategoryImage} key={i}>
            <S.MainCategoryItems.Container
              $option="flex_column"
              $row_gap="4px"
              onClick={() => alwaysPageNav(CategoryNumber, false)}
            >
              <LazyImage
                src={CategoryImage}
                alt="카테고리 아이콘"
                style={S.MainCategoryItems.CouponImage}
              />
              <S.MainCategoryItems.CouponName $fontStyle={Noto_body3_r12} $color="var(--black-50)">
                {CategoryName}
              </S.MainCategoryItems.CouponName>
            </S.MainCategoryItems.Container>
          </RenderIf>
        ))}
        <S.MainCategoryItems.Container
          $option="flex_column"
          $row_gap="4px"
          onClick={() => alwaysPageNav(categoryList?.at(0)?.CategoryNumber as number, false)}
        >
          <LazyImage
            src={main_category_shortcut_all_icon}
            style={S.MainCategoryItems.CouponImage}
            alt="전체보기 아이콘"
          />
          <S.MainCategoryItems.CouponName $fontStyle={Noto_body3_r12} $color="var(--black-50)">
            전체보기
          </S.MainCategoryItems.CouponName>
        </S.MainCategoryItems.Container>
      </S.MainCategoryItemsContainer>
    </S.MainCategoryShortcutContainer>
  )
}
export default MainCategoryShortcut

const S = {
  MainCategoryShortcutContainer: styled(Container)`
    margin: -10px auto 0 auto;
    max-width: 420px;
    ${mediaMaxWidth('460')} {
      max-width: unset;
      padding: 0 20px;
    }
  `,
  MainCategoryItemsContainer: styled.div`
    display: grid;
    padding: 0 10px;
    grid-template-columns: repeat(4, 52px);
    justify-content: space-between;
    align-content: start;
    width: 100%;
    gap: 10px;
    background-color: var(--white);
  `,
  MainCategoryItems: {
    Container: styled(Container)`
      border-radius: 12px;
      width: 100%;
      gap: 4px;
      margin: 0 auto;
      cursor: pointer;
    `,
    CouponImage: css`
      background-color: var(--black-4);
      border-radius: 12px;
      max-width: 52px;
      min-width: 52px;
      min-height: 52px;
      max-height: 52px;
      padding: 6px;
      display: flex;
      justify-items: center;
      justify-content: center;
      &:hover {
        transform: scale(1.05);
      }
      > img {
        width: 40px;
        height: 40px;
      }
    `,
    CouponName: styled(Typography)`
      ${ellip('line1')};
      text-align: center;
    `,
  },
}
